module.exports = __webpack_public_path__ + "img/hr-red-desert-decal-06.7ec23343.png";